const inlineText = (node) => {
  switch (node.type) {
    case 'text':
      return node.text ?? '';
    case 'hard_break':
      return '\n';
    case 'mention':
      return `@${node.attrs?.label ?? ''}`;
    case 'goalMention':
      return node.attrs?.title ?? '';
    case 'emoji':
      return node.attrs?.emoji ?? '';
    default:
      return '';
  }
};

const textBlockTypes = ['paragraph', 'heading', 'code_block'];

const blockText = (node) => {
  const content = node.content ?? [];
  if (textBlockTypes.includes(node.type)) {
    return content.map(inlineText).join('');
  }
  return content.map(blockText).filter((text) => text !== '').join('\n');
};

export const documentText = (doc) => (doc === null || doc === undefined ? '' : blockText(doc));
